<template>
  <Users />
</template>

<script>
import Users from '@/components/admin/UsersList.vue'

export default {
  name: 'AdministrationUsers',
  components: { Users }
}
</script>

<style scoped>

</style>
